import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import { useTranslate } from "./TranslationText";
import { Link } from "react-router-dom";
import { showFirst12Words, showFirst17Words, showFirst22Words } from "../helper/showFirstSixWords";
import NetaqInput from "./NetaqInput";
import ServiceCardItem from "./ServiceCardItem";
import SearchBox from "./SearchBox";
import SectionTitle from "./SectionTitle";

const fetch = process.env.REACT_APP_HOME_PAGE_SERVICES_lIST_ID;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function ServicesSection({ isHomePage = false }) {
  const BaseURL = process.env.REACT_APP_BASE_URL;
  const { currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );
  const [services, setServices] = useState([{
    id: '',
    serviceName: "",
    category: [],
    estimateTime: "",
    feesAmount: 0,
    feesDescription: "",
    requiredDocuments: '',
    serviceForm: "",
    serviceImage: '',
    subTitle: "",
    termsAndConditions: ''
  }]);
  const [total, setTotal] = useState(0);
  const { translate } = useTranslate();

  const [mostUsedServices, setMostUsedServices] = useState([]);
  const [registerationServices, setRegisterationServices] = useState([]);
  const [notarisationServices, setNotarisationServices] = useState([]);
  const [approvalServices, setApprovalServices] = useState([]);
  const [activeTab, setActiveTab] = useState('Most Used Services')


  function getCurrentLanguageUmbraco() {
    // Replace this with your logic to retrieve the current language
    // For example, you can retrieve it from localStorage or from a state variable
    const lang = localStorage.getItem("eahsLang") ?? "en";
    if (lang == "en") return 'en-US';
    else return 'ar-AE'; // Defaulting to English for demonstration
  }


  useEffect(() => {
    async function getdata() {
      const umbraco = await axios.get(`/umbraco/delivery/api/v1/content?fetch=${fetch}&skip=0&take=50`, {
        headers: {
          "accept-language": getCurrentLanguageUmbraco(),

        }
      })
      const formattedData = umbraco.data?.items.map((item) => ({
        id: item?.id ?? '',
        serviceName: showFirst12Words(item?.name) ?? '',
        category: item?.properties?.category ?? [],
        estimateTime: item?.properties?.estimateTime ?? "",
        feesAmount: item?.properties?.feesAmount ?? 0,
        feesDescription: item?.properties?.feesDescription ?? "",
        requiredDocuments: item?.properties?.requiredDocuments?.markup ?? '',
        serviceForm: item?.properties?.serviceForm ?? "",
        serviceImage: item.properties?.serviceImage ? item.properties?.serviceImage[0]?.url : '',
        subTitle: showFirst17Words(item.properties?.subTitle) ?? "",
        termsAndConditions: item?.properties?.termsAndConditions?.markup ?? '',
        serviceIcon: item.properties?.serviceIcon ? item.properties?.serviceIcon[0]?.url : ''
      }));
      setTotal(umbraco.data?.total)
      setServices(formattedData);
      setMostUsedServices(formattedData.filter(service => service.category.includes("Most Used Services")))
      setRegisterationServices(formattedData.filter(service => service.category.includes("Registration Services")))
      setNotarisationServices(formattedData.filter(service => service.category.includes("Notarisation Services")))
      setApprovalServices(formattedData.filter(service => service.category.includes("Approval Services")))
    }
    getdata();

  }, [currentLanguage])
  const [searchKeyWord, setSearchKeyWord] = useState('');

  const filterdServices = services.filter(item => searchKeyWord.toLowerCase() === '' || item.serviceName.toLowerCase().includes(searchKeyWord.toLowerCase()));
  const tabsClasses = isHomePage ? "col-lg-3 col-md-4 col-sm-6 col-8 my-2 text-center px-0" : "col-xl-2-5 col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0";


  return (
    <>

      {total > 0 &&
        <div className="second_services_section_container">
          {/* Tabs */}
          {!isHomePage &&
            <div className="mb-3">
              <SearchBox key={'servicesSearchBox'} value={searchKeyWord} onChange={(e) => {
                setActiveTab('All');
                setSearchKeyWord(e.target.value);
              }} />


            </div>
          }
          <div className={isHomePage ? "container mobile-extra-padding pb-3" : 'pb-3 mobile-extra-padding'}>
            {isHomePage &&
              <SectionTitle section_id={"services"} isContainer={false} section_name={translate('web.ourServices', "our services")} />
            }
            <div className="row second_section_bar " style={{ cursor: 'pointer', justifyContent: isHomePage ? 'space-between' : 'flex-start' }}>
              {mostUsedServices.length > 0 &&
                <div
                  className={tabsClasses} style={{ minWidth: 250 }}
                  id="second_most_used_services"
                  onClick={() => setActiveTab('Most Used Services')}
                >

                  <span className={`${activeTab == 'Most Used Services' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate('web.mostUsedServices', 'Most Used Services')}</span>

                  <div className="service_bar_underline" style={activeTab == 'Most Used Services' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
              }
              {registerationServices.length > 0 &&
                <div
                  className={tabsClasses} style={{ minWidth: 250 }}
                  id="second_registration_services"
                  onClick={() => setActiveTab('Registration Services')}
                >

                  <span className={`${activeTab == 'Registration Services' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate('web.registrationServices', 'Registration Services')}</span>

                  <div className="service_bar_underline" style={activeTab == 'Registration Services' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
              }

              {notarisationServices.length > 0 &&
                <div
                  className={tabsClasses} style={{ minWidth: 250 }}
                  id="second_notarisation_services"
                  onClick={() => setActiveTab('Notarisation Services')}
                >

                  <span className={`${activeTab == 'Notarisation Services' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate('web.notarisationServices', 'notarisation Services')}</span>
                  <div className="service_bar_underline" style={activeTab == 'Notarisation Services' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
              }
              {approvalServices.length > 0 &&
                <div
                  className={tabsClasses} style={{ minWidth: 250 }}
                  id="second_approval_services"
                  onClick={() => setActiveTab('Approval Services')}
                >

                  <span className={`${activeTab == 'Approval Services' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate('web.approvalServices', 'Approval Services')}</span>
                  <div className="service_bar_underline" style={activeTab == 'Approval Services' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
                </div>
              }
              {!isHomePage &&
                <div
                  className={tabsClasses} style={{ minWidth: 250 }}
                  id="second_approval_services"
                  onClick={() => setActiveTab('All')}
                >
                  {/* <img src={`${BaseURL}/assets/img/past.png`} alt="alt" /> */}
                  <span className={`${activeTab == 'All' ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate('web.all', 'All')}</span>
                  <div className="service_bar_underline" style={activeTab == 'All' ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>

                </div>}
            </div>
          </div>
          {/* services Section */}
          <div className={isHomePage ? "container" : ''} >
            <div className="row rtl" id="">
              {activeTab == 'Most Used Services' && mostUsedServices.length > 0 &&
                mostUsedServices.map((service, index) => (
                  <ServiceCardItem service={service} translate={translate} index={index} />
                ))}
              {activeTab == 'Registration Services' && registerationServices.length > 0 &&
                registerationServices.map((service, index) => (
                  <ServiceCardItem service={service} translate={translate} />
                ))}
              {activeTab == 'Notarisation Services' && notarisationServices.length > 0 &&
                notarisationServices.map((service, index) => (
                  <ServiceCardItem service={service} translate={translate} />
                ))}
              {activeTab == 'Approval Services' && approvalServices.length > 0 &&
                approvalServices.map((service, index) => (
                  <ServiceCardItem service={service} translate={translate} />
                ))}

              {activeTab == 'All' && !isHomePage && services.length > 0 &&
                filterdServices.map((service, index) => (
                  <ServiceCardItem service={service} translate={translate} />
                ))}
            </div>
          </div>
        </div>
      }
    </>

  );
}

